import { Box, BoxProps } from '@mantine/core';
import React from 'react';

/**
 * Content container for wizard step
 * This component should be used inside WizardStepRoot
 * @see WizardStepRoot
 * @example
 * ```tsx
 * <WizardStepContent>
 *   <Text>Content for step</Text>
 * </WizardStepContent>
 * ```
 */
export const WizardStepContent: React.FC<BoxProps> = ({
  children,
  sx,
  ...boxProps
}) => (
  <Box
    px={16}
    pt={24}
    sx={{
      maxHeight: '100%',
      overflow: 'auto',
      ...sx,
    }}
    {...boxProps}
  >
    {children}
  </Box>
);
